import firebase, { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
// };

const firebaseConfig = {
  apiKey: "AIzaSyCXMFlcdQGyBJ7GGxhE_G-BSdI8OiR7vHQ",
  authDomain: "picksnprizez.firebaseapp.com",
  projectId: "picksnprizez",
  storageBucket: "picksnprizez.appspot.com",
  messagingSenderId: "224562251031",
  appId: "1:224562251031:web:0ef96bb11a0c4bd075e352",
  measurementId: "G-1TDZ1HV1Y4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);